<h3 class="headline5-main-title">Trip Details</h3>
<div class="travellers-section">
  <pc-icon size="small" [icon]="tripDetailsIcons().applicant"></pc-icon>
  <p>{{ travelersAmount() }}</p>
</div>

@for (destination of flaggedDestinations(); track destination; let index = $index) {
  <div class="destination-label" [class.visible]="isDestinationsExpanded() || index < VISIBLE_DESTINATIONS">
    <img
      class="destination-flag"
      [alt]="selectedDestinationAlt() + destination.titleLocal"
      [src]="destination.destinationIcon"
    />
    <p>{{ destination.titleLocal }}</p>
  </div>
}

@if (flaggedDestinations().length > VISIBLE_DESTINATIONS) {
  <button class="toggle-button" (click)="toggleDestinations()">
    {{ toggleState() }}
  </button>
}
<div class="date-range-section">
  <pc-icon size="small" [icon]="tripDetailsIcons().calendar"></pc-icon>
  <p>{{ quoteTripDetailsData().formattedDateRange }}</p>
</div>
